export default __webpack_public_path__ + "static/media/rotate.d894249e.webp";